import { useContext, useEffect, useState } from 'react';
import { Route, Routes} from "react-router-dom";
import Home from './pages/Home/Home';
import Navbar from './components/Navbar/Navbar';
import Courses from './pages/Courses/Courses';
import Contact from './pages/Contact/Contact';
import About from './pages/About/About';
import Login from './pages/Login/Login';
import SignUp from './pages/SignUp/SignUp';
import CoursePage from './pages/CoursePage/CoursePage';
import { CartProvider } from './context/CartContext';
import './App.css';
import Cart from './pages/Cart/Cart';
import Footer from './components/Footer/Footer';
import Payment from './pages/Payment/Payment';
import { UserProfile } from './pages/Profile/Profile';
import { CurrentUserContext, CurrentUserProvider } from './context/CurrentUserContext';
import CourseCatalog from './pages/CourseCatalog/CourseCatalog';
import BecomeInstructor from './pages/Instructor/BecomeInstructor/BecomeInstructor';
import Callback from './pages/Stripe/Callback';
import CreateCourse from './pages/Instructor/CreateCourse/CreateCourse';
import InstructorIndex from './pages/Instructor/InstructorIndex';
import CourseView from './pages/Instructor/CourseView/CourseView';
import Lessons from './pages/Lessons/Lessons';


function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isInstructor, setIsInstructor] = useState<boolean>(false);
  const role = localStorage.getItem("userRole");
  
  
  useEffect(() => {
    if (role) {
      setIsLoggedIn(true)
      
      if (role === "Instructor") {
        setIsInstructor(true)
      } else {
        setIsInstructor(false)
      }
    }
  },[role])
  console.log(process.env.REACT_APP_SECRET_KEY);
  
  

  return (
    <CurrentUserProvider>
      <CartProvider>
        <Navbar />
        
      
      <div className=''>
              {isLoggedIn && !isInstructor &&
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/courses" element={<Courses />} />
                  <Route path="/courses/:courseName" element={<CoursePage />} />
                  <Route path="/payment" element={<Payment />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path='/course/:category' element={<CourseCatalog />} />
                  <Route path="/profile" element={<UserProfile />} />
                  <Route path='/instructor/become-instructor' element={<BecomeInstructor />} />
                  <Route path='/stripe/callback' element={<Callback />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/courses/lessons/:title" element={<Lessons />} />
              
                  
                </Routes>
            }
            {isLoggedIn && isInstructor && 
              <Routes>
                <Route path="/create-course" element={<CreateCourse />} />
              <Route path="/instructor" element={<InstructorIndex />} />
              <Route path="/profile" element={<UserProfile />} />
              <Route path="/login" element={<Login />} />
              <Route path='/instructor/courses/view/:name' element={<CourseView />} />
            </Routes>
            }
              {!isLoggedIn &&
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/courses" element={<Courses />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/courses/:courseName" element={<CoursePage />} />
                  <Route path='/course/:category' element={<CourseCatalog />} />
                  <Route path="/cart" element={<Cart />} />
              <Route path="/register" element={<SignUp />} />
              <Route path='/stripe/callback' element={<Callback />}/>
              <Route path="/instructor" element={<InstructorIndex />} />
              <Route path="/courses/lessons/:title" element={<Lessons />} />
                
                </Routes>}
          

        
      </div>

      <Footer />
      
        </CartProvider>
        
      </CurrentUserProvider>
     
  );
} 

export default App;
